// Modules
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import pluralize from 'pluralize';
import store from 'app-store';

import { AUTH_SERVICES } from 'constants';
import {
  Button,
  SecondaryButton,
  SubmitButton,
  RemoveButton
} from 'components/widgets/buttons';
import { Card } from 'components/content-containers/cards';
import { Page, PageHeader, PageContent } from 'components/page';
import { SelectInput, TextInput, CheckboxInput } from 'components/forms/form-elements';
import { SimpleReduxForm } from 'components/forms/form-structure';
import { UserSelect } from 'components/forms/selects';
import { alerts } from 'modules/alerts/actions';
import Auth from 'services/data/auth';
import DriveFile from 'components/models/files/drive-file';
import Form from 'services/data/form';
import Person from 'services/data/person';
import PurchaseOrder from 'services/data/purchase-order';
import SVG from 'components/widgets/icons/svg';
import Search from 'services/data/search';
import Settings from 'services/data/settings';
import SimpleArrayForm from 'components/forms/simple-array-form';
import Tooltip from 'components/widgets/overlays/tooltip';
import * as pageData from 'modules/page-data/actions';

function RenderVehicleMap({ fields }) {
  return (
    <div className="simple-array-input-list">
      <table className="table table-borderless">
        <thead>
          <tr>
            <th className="py-3 px-0">Ticket ID</th>
            <th className="py-3 px-0">Location ID</th>
            <th className="py-3 px-0">Location Name</th>
            <th className="py-3 px-0"></th>
          </tr>
        </thead>
        <tbody>
          { fields.map((name, index) =>
            <tr key={index}>
              <td className="p-0 pr-3"><Field component={TextInput} name={`${name}ticketId`} /></td>
              <td className="p-0 pr-3"><Field component={TextInput} name={`${name}vehicleId`} /></td>
              <td className="p-0 pr-3"><Field component={TextInput} name={`${name}vehicleName`} /></td>
              <td className="p-0 align-middle">
                <div className="mb-3">
                  <span className="form-element remove-button" ><RemoveButton onClick={() => fields.remove(index)} /></span>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <a onClick={() => fields.push({ vehicleId: null, vehicleName: null, ticketId: null })}>Add Item</a>
    </div>
  );
}

// Component
class ViewSettings extends React.Component {
  static propTypes = {
    settings: PropTypes.object,
    currentUser: PropTypes.object,
    templates: PropTypes.array,
    users: PropTypes.array
  };

  constructor() {
    super();
    this.notifications = [{
      name: 'Clear',
      data: {
        afterHoursCount: 0,
        unclaimedCount: 0,
        unclaimed: []
      }
    }, {
      name: 'Email',
      data: {
        id: 100,
        type: 'email',
        action: 'add',
        title: 'Amy Grice - Peninsula Light Company',
        details: 'IDEA! Internal IQGeo map for deployment status',
        afterHoursCount: 0,
        unclaimedCount: 1,
        unclaimed: [{ type: 'email', id: 100 }]
      }
    }, {
      name: 'Monitoring Alert',
      data: {
        id: 236913,
        type: 'monitoringalert',
        action: 'add',
        title: 'storage.gogus.com',
        details: 'Host down 2m',
        afterHoursCount: 0,
        unclaimedCount: 1,
        unclaimed: [{ type: 'monitoringalert', id: 236913 }]
      }
    }, {
      name: 'Escalated Email',
      data: {
        id: 100,
        type: 'email',
        action: 'escalated',
        title: 'Amy Grice - Peninsula Light Company',
        details: 'IDEA! Internal IQGeo map for deployment status',
        afterHoursCount: 0,
        unclaimedCount: 1,
        unclaimed: [{ type: 'email', id: 100 }]
      }
    }];
    this.state = { loadingSettings: true };
    this.fileRenderer = this.fileRenderer.bind(this);
    this.setSettings = this.setSettings.bind(this);
    this.setAfterHours = this.setAfterHours.bind(this);
    this.resyncAuth = this.resyncAuth.bind(this);
    this.sendNotification = this.sendNotification.bind(this);
  }

  componentDidMount() {
    Settings.initializeSocket()
      .then(() => this.setState({ loadingSettings: false }));
  }

  setAfterHours(values) {
    this.setSettings({
      afterHoursStart: _.padStart(values.afterHoursStart, 4, '0'),
      afterHoursEnd: _.padStart(values.afterHoursEnd, 4, '0'),
      afterHoursOverride: values.afterHoursOverride ? 'Enabled' : 'Disabled'
    });
  }

  setSettings(values) {
    return Settings.update(values)
      .then((output) => {
        pageData.update('settings', output);
        alerts.success({ title: 'Settings saved!' });
      });
  }

  alertUsersOfNewUpdates() {
    const { users } = this.props;
    const changes = _.map(users, user => ({ id: user.id, hasViewedLatestPortalChanges: false }));

    Person.updateMany(changes);
  }

  resyncAuth(model, all, service) {
    this.setState({ syncing: `${service || ''}${model}${all ? 'all' : ''}` });

    return Auth.sync({ model, service, all })
      .then(response => {
        this.setState({ syncing: false });

        alerts.success({ title: `${response.count} ${pluralize(model)} ${all ? '(all)' : ''} synced to ${service || 'all services'}.` });
      });
  }

  fileRenderer(file) {
    return <DriveFile item={file} forSelect />;
  }

  sendNotification(values) {
    const data = {
      sendTo: values.sendTo,
      payload: _.find(this.notifications, { name: values.type }).data
    };

    return Settings.testNotification(data)
      .then(response => {
        console.log(`----------messages--------\n`, response);

        alerts.success({ title: 'Escalated notification sent', subtitle: `
          Multicast ID: ${response.multicast_id}\n
          Messages: ${JSON.stringify(response.results)}
        ` });
      });
  }

  syncContacts(data) {
    if (!data.user) return alerts.warning({ title: 'Select a user!' });

    return Settings.syncContacts(data).then(response => alerts.success({ title: response.message }));
  }

  render() {
    const { settings, templates } = this.props;
    const { syncing, loadingSettings } = this.state;
    const indexes = ['company', 'person', 'purchaseorder', 'ticket', 'timereport'];
    const urlSettings = _.pick(settings, _.filter(_.keys(settings), key => _.includes(key, 'AppUrl')));
    const token = store.getState().auth.token;
    const xeroUrl = `/api/xero-authenticate?access_token=${token}`;

    return (
      <Page className="settings-page">
        <PageHeader title="Settings" />
        <PageContent className="settings bg-medium-blue-grey" fetching={loadingSettings}>
          <Card>
            <h2>Test notifications</h2>
            <SimpleReduxForm
              form="testEmailNotification"
              preventAutoFocus
              customSubmitArea
              onSubmit={this.sendNotification}
            >
              <div className="row">
                <div className="col">
                  <Field component={UserSelect} placeholder="All" label="Send to" name="sendTo" />
                </div>
                <div className="col">
                  <Field
                    component={SelectInput}
                    placeholder="Select Type"
                    label="Notification Type"
                    valueKey="name"
                    labelKey="name"
                    name="type"
                    options={this.notifications}
                  />
                </div>
              </div>
              <SubmitButton content="Send" />
            </SimpleReduxForm>
          </Card>

          <Card>
            <h2>Start Contact Sync</h2>
            <SimpleReduxForm
              form="startContactSync"
              preventAutoFocus
              customSubmitArea
              onSubmit={this.syncContacts}
            >
              <div className="row">
                <div className="col">
                  <Field component={UserSelect} placeholder="Select a user" label="Start sync for" name="user" />
                </div>
              </div>
              <SubmitButton content="Start Sync" />
            </SimpleReduxForm>
          </Card>

          <Card>
            <h2>Replenishment Locations</h2>
            <SimpleArrayForm preventAutoFocus form="vehicles" rowComponent={RenderVehicleMap} items={settings && settings.vehicles || []} onSubmit={values => this.setSettings({ vehicles: values.items })} />
          </Card>

          <Card>
            <h2>Replenishment Products</h2>
            <SimpleArrayForm preventAutoFocus form="vehicle-replenishment-products" items={settings.vehicleReplenishmentProducts || []} onSubmit={values => this.setSettings({ vehicleReplenishmentProducts: values.items })} />
          </Card>
          
          <Card className="app-urls">
            <h2>App URLs</h2>
            <SimpleReduxForm
              form="appSyncSettings"
              onSubmit={this.setSettings}
              initialValues={urlSettings}
              preventAutoFocus
            >
              <table className="table form-table">
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Create Company URL</th>
                    <th>
                      <div className="flex">
                        <div className="grow">Update Company URL</div>
                        <Tooltip title={'Resync active companies to all services'}>
                          <Button loaderColor="#000" showLoading={syncing === 'company'} className="refresh-button p-2 nowrap" onClick={() => this.resyncAuth('company')}>
                            <SVG src="svg/refresh.svg" />
                          </Button>
                        </Tooltip>
                        <Tooltip title={'Resync all companies to all services'}>
                          <Button loaderColor="#000" showLoading={syncing === 'companyall'} className="refresh-button p-2 nowrap" onClick={() => this.resyncAuth('company', true)}>
                            <SVG src="svg/refresh.svg" /> All
                          </Button>
                        </Tooltip>
                      </div>
                    </th>
                    <th>Create Person URL</th>
                    <th>
                      <div className="flex">
                        <div className="grow">Update Person URL</div>
                        <Tooltip title={'Resync active users to all services'}>
                          <Button loaderColor="#000" showLoading={syncing === 'person'} className="refresh-button p-2 nowrap" onClick={() => this.resyncAuth('person')}>
                            <SVG src="svg/refresh.svg" />
                          </Button>
                        </Tooltip>
                        <Tooltip title={'Resync all users to all services'}>
                          <Button loaderColor="#000" showLoading={syncing === 'personall'} className="refresh-button p-2 nowrap" onClick={() => this.resyncAuth('person', true)}>
                            <SVG src="svg/refresh.svg" /> All
                          </Button>
                        </Tooltip>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {_.map(AUTH_SERVICES, service =>
                    <tr key={service}>
                      <td>{_.startCase(service)}</td>
                      <td><Field component={TextInput} name={`${service}CreateCompanyAppUrl`} /></td>
                      <td>
                        <div className="flex">
                          <Field component={TextInput} name={`${service}UpdateCompanyAppUrl`} />
                          <Tooltip title={`Resync active companies to ${service}`}>
                            <Button loaderColor="#000" showLoading={syncing === `${service}company`} className="refresh-button p-2 nowrap" onClick={() => this.resyncAuth('company', false, service)}>
                              <SVG src="svg/refresh.svg" />
                            </Button>
                          </Tooltip>
                          <Tooltip title={`Resync all companies to ${service}`}>
                            <Button loaderColor="#000" showLoading={syncing === `${service}companyall`} className="refresh-button p-2 nowrap" onClick={() => this.resyncAuth('company', true, service)}>
                              <SVG src="svg/refresh.svg" /> All
                            </Button>
                          </Tooltip>
                        </div>
                      </td>
                      <td><Field component={TextInput} name={`${service}CreateUserAppUrl`} /></td>
                      <td>
                        <div className="flex">
                          <Field component={TextInput} name={`${service}UpdateUserAppUrl`} />
                          <Tooltip title={`Resync active users to ${service}`}>
                            <Button loaderColor="#000" showLoading={syncing === `${service}person`} className="refresh-button p-2 nowrap" onClick={() => this.resyncAuth('person', false, service)}>
                              <SVG src="svg/refresh.svg" />
                            </Button>
                          </Tooltip>
                          <Tooltip title={`Resync all users to ${service}`}>
                            <Button loaderColor="#000" showLoading={syncing === `${service}personall`} className="refresh-button p-2 nowrap" onClick={() => this.resyncAuth('person', true, service)}>
                              <SVG src="svg/refresh.svg" /> All
                            </Button>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </SimpleReduxForm>
          </Card>
          <Card>
            <h2>After Hours</h2>
            <SimpleReduxForm
              form="afterHoursSettings"
              onSubmit={this.setAfterHours}
              preventAutoFocus
              initialValues={{ ..._.pick(settings, ['afterHoursEnd', 'afterHoursStart']), afterHoursOverride: settings.afterHoursOverride === 'Enabled' }}
            >
              <Field
                component={TextInput}
                label="After Hours Start"
                name="afterHoursStart"
              />
              <Field
                component={TextInput}
                label="After Hours End"
                name="afterHoursEnd"
              />
              <Field
                component={CheckboxInput}
                label="After Hours Override"
                name="afterHoursOverride"
                value="Enabled"
              />
            </SimpleReduxForm>
          </Card>
          { templates &&
            <Card className="base-template-select">
              <h2>Base Templates</h2>
              <SimpleReduxForm
                form="documentBaseSettings"
                onSubmit={this.setSettings}
                preventAutoFocus
                initialValues={_.pick(settings, ['documentBaseTemplate', 'sheetBaseTemplate', 'slideBaseTemplate'])}
              >
                <Field
                  component={SelectInput}
                  label="Doc Template"
                  valueKey="id"
                  labelKey="name"
                  name="documentBaseTemplate"
                  optionRenderer={this.fileRenderer}
                  valueRenderer={this.fileRenderer}
                  options={templates}
                />
                <Field
                  component={SelectInput}
                  label="Sheet Template"
                  valueKey="id"
                  labelKey="name"
                  name="sheetBaseTemplate"
                  optionRenderer={this.fileRenderer}
                  valueRenderer={this.fileRenderer}
                  options={templates}
                />
                <Field
                  component={SelectInput}
                  label="Slide Template"
                  valueKey="id"
                  labelKey="name"
                  name="slideBaseTemplate"
                  optionRenderer={this.fileRenderer}
                  valueRenderer={this.fileRenderer}
                  options={templates}
                />
                <Field
                  component={SelectInput}
                  label="Onboarding Form Template"
                  valueKey="id"
                  labelKey="name"
                  name="onboardingTemplate"
                  optionRenderer={this.fileRenderer}
                  valueRenderer={this.fileRenderer}
                  options={templates}
                />
                <Field
                  component={SelectInput}
                  label="Offboarding Form Template"
                  valueKey="id"
                  labelKey="name"
                  name="offboardingTemplate"
                  optionRenderer={this.fileRenderer}
                  valueRenderer={this.fileRenderer}
                  options={templates}
                />
              </SimpleReduxForm>
            </Card>
          }
          <Card>
            <h2>Person Tags</h2>
            <SimpleArrayForm preventAutoFocus form="person-tags" items={settings.personTags || []} onSubmit={values => this.setSettings({ personTags: values.items })} />
          </Card>
          <Card>
            <h2>Email Blacklist Addresses</h2>
            <SimpleArrayForm preventAutoFocus form="blacklist-emails" items={settings.blacklistEmails || []} onSubmit={values => this.setSettings({ blacklistEmails: values.items })} />
          </Card>
          <Card>
            <h2>Email Blacklist Domains</h2>
            <SimpleArrayForm preventAutoFocus form="blacklist-domains" items={settings.blacklistDomains || []} onSubmit={values => this.setSettings({ blacklistDomains: values.items })} />
          </Card>
          <Card>
            <h2>Email Blacklist Subject</h2>
            <SimpleArrayForm preventAutoFocus form="blacklist-subjects" items={settings.blacklistSubjects || []} onSubmit={values => this.setSettings({ blacklistSubjects: values.items })} />
          </Card>
          <Card>
            <h2>Email Auto-escalate Addresses</h2>
            <SimpleArrayForm preventAutoFocus form="auto-escalate-emails" items={settings.autoEscalateEmails || []} onSubmit={values => this.setSettings({ autoEscalateEmails: values.items })} />
          </Card>
          <Card>
            <h2>Email Blacklist Recipients</h2>
            <SimpleArrayForm preventAutoFocus form="blacklist-recipients" items={settings.blacklistRecipients || []} onSubmit={values => this.setSettings({ blacklistRecipients: values.items })} />
          </Card>
          <Card>
            <h2>Phone Blacklist Numbers (E164 format)</h2>
            <SimpleArrayForm preventAutoFocus form="blacklist-phones" items={settings.blacklistPhones || []} onSubmit={values => this.setSettings({ blacklistPhones: values.items })} />
          </Card>
          <Card>
            <h2>Rebuild search indexes</h2>
            <div className="flex">
              {_.map(indexes, index =>
                <SecondaryButton key={index} onClick={() => Search.rebuildIndex(index)}>Rebuild {index}</SecondaryButton>
              )}
            </div>
          </Card>
          <Card>
            <h2>Run automation</h2>
            <div className="flex">
              <SecondaryButton onClick={() => PurchaseOrder.run('amazon')}>Start Amazon</SecondaryButton>
              <SecondaryButton onClick={() => PurchaseOrder.run('dell')}>Start Dell</SecondaryButton>
              <SecondaryButton onClick={() => PurchaseOrder.run('cdw')}>Start CDW</SecondaryButton>
            </div>
          </Card>
          
          <Card>
            <h2>Quick Links</h2>
            <div className="flex">
              <SecondaryButton onClick={() => Form.forceUpdate()}>Check For Company Form Submissions</SecondaryButton>
              <SecondaryButton onClick={() => this.alertUsersOfNewUpdates()}>Alert Users of New Updates</SecondaryButton>
              <a className="button btn-secondary" href={xeroUrl}>Authenticate Xero</a>
            </div>
          </Card>
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  currentUser: state.auth.currentUser,
  settings: state.pageData.settings,
  templates: state.pageData.templateFiles,
  users: state.pageData.selectUsers
}))(ViewSettings);



// WEBPACK FOOTER //
// ./app/routes/settings/view-settings.js